import { render, staticRenderFns } from "./QuestionDetails.vue?vue&type=template&id=1a971f38&"
import script from "./QuestionDetails.vue?vue&type=script&lang=js&"
export * from "./QuestionDetails.vue?vue&type=script&lang=js&"
import style0 from "./QuestionDetails.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "QuestionDetails.vue"
export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib'
import { VBadge } from 'vuetify/lib'
import { VBtn } from 'vuetify/lib'
import { VContainer } from 'vuetify/lib'
import { VDivider } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VList } from 'vuetify/lib'
import { VListTile } from 'vuetify/lib'
import { VMenu } from 'vuetify/lib'
import { VSpacer } from 'vuetify/lib'
installComponents(component, {
  VAvatar,
  VBadge,
  VBtn,
  VContainer,
  VDivider,
  VIcon,
  VLayout,
  VList,
  VListTile,
  VMenu,
  VSpacer,
})
